import { createContext, useLayoutEffect, useState, useEffect } from 'react';
import { axiosInstance } from '../apis/axios';
import moment from 'moment';
import api from '../apis';

import { useNavigate, useLocation } from 'react-router-dom';
import { getUserDetail,useLocalStorageListener  } from '../hooks/handleUserLocalStorage';


// import { showNotiLoaderError } from '../components/general/antd-loader';
// import { WarningTwoTone } from '@ant-design/icons';
// import Config from '../config';

//handle user login status
const LoginStatusContext = createContext({});

const heartBeatInterval = 5000; //trigger every 5 sec;
let timer = null;

/////////////////////
//      this timer will keep check current login status, if token failed then logout user
///////////////////////
const WithCheckLoginStatus = ({ children }: any) => {
    // const [cookies, setCookie, removeCookie] = useCookies(['user']);
    const location = useLocation();
    useEffect(() => {

        return () => {
            clearTimeout(timer); // Clean up the interval on unmount
        }
    }, []);

    //if logined
    // useEffect(() => {
    //     if(cookies.user){
    //         startTimer();
    //     }else{
    //         clearTimeout(timer);
    //     }
    // }, [cookies]);

    useLocalStorageListener((localdata) => {
        let localUser = getUserDetail();

        if(localUser?.user){
            startTimer();
        }else{
            clearTimeout(timer);
        }
    });

    // const startTimer = () =>{
    //     clearInterval(timer);
    //     timer = setInterval(() => {
    //         if(cookies.user){
    //             checkHearBeat();
    //         }
    //     }, heartBeatInterval);
    // }

    const startTimer = () => {
  
        clearTimeout(timer); // Clear any existing timeout
        // Start the heartbeat check
        timer = setTimeout(() => {
            let localUser = getUserDetail();
            if (localUser.user) {
                checkHearBeat();
            }
        }, heartBeatInterval);
    };

    const checkHearBeat = async () => {
        // May have delay in location update when login
        let isLiveQuotes = location.pathname === "/" || location.pathname === "/login" ? true : false;
        
        // Check session ack with an API call (modify accordingly)
        //console.log("WithCheckLoginStatus.getSessAck");
        let hasFocus = document.hasFocus();
        let result = await api.getSessAck(isLiveQuotes,hasFocus);

        // Log the current time
        // let currentTime = new Date();
        // let hours = currentTime.getHours();
        // let minutes = currentTime.getMinutes();
        // let seconds = currentTime.getSeconds();
        //console.log(`${hours}:${minutes}:${seconds}`);

        // After checking, trigger the next check by calling startTimer again
        startTimer();
    };

    return (
        <LoginStatusContext.Provider value={{  }}>
            {/* {timeoutModal == true && (
                <Modal
                    title={
                        <div className="d-flex">
                            <WarningTwoTone
                                twoToneColor="#ed0d0d"
                                style={{
                                    fontSize: '16px',
                                    paddingTop: '2px'
                                }}
                            />
                            <div>Timeout Warning</div>
                        </div>
                    }
                    maskClosable={false}
                    keyboard={false}
                    closable={false}
                    open={timeoutModal}
                    okText="Stay logged on"
                    onOk={handleSessAck}
                    cancelText="Log off"
                    onCancel={handleLogout}
                >
                    <p>
                        You will automatically be logged off in {expiredTimer}{' '}
                        seconds
                    </p>
                </Modal>
            )} */}

            {children}
        </LoginStatusContext.Provider>
    );
};

export default WithCheckLoginStatus;
